interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const baseSchema = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(baseSchema) }}
    />
  );
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '私密视频',
    url: 'https://www.simishipin.com',
    description: '私密视频品牌提供红桃视频、西瓜视频免费、小蓝视频等综合平台免费在线观看，高清画质不缓冲。',
    logo: 'https://readdy.ai/api/search-image?query=A%20modern%20play%20button%20icon%20logo%20with%20warm%20red%20gradient%2C%20minimal%20design%2C%20clean%20background&width=512&height=512&seq=logo-sq&orientation=squarish',
    sameAs: [
      'https://weibo.com/simishipin',
      'https://www.zhihu.com/org/simishipin',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-000-0000',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };
}

export function getWebsiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '私密视频',
    url: 'https://www.simishipin.com',
    description: '私密视频 - 红桃视频西瓜视频免费高清在线看 | 小蓝视频茄子视频不缓冲',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://www.simishipin.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getFAQSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '私密视频支持哪些视频平台？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '私密视频聚合了红桃视频、西瓜视频、小蓝视频、茄子视频、久久视频、芒果视频等六大视频平台的优质内容，用户可以在一个平台畅享全网视频资源。',
        },
      },
      {
        '@type': 'Question',
        name: '私密视频的观看画质如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '私密视频支持4K超高清、1080P全高清等多种画质选择，采用智能码率自适应技术，确保在不同网络环境下都能获得流畅不缓冲的观看体验。',
        },
      },
      {
        '@type': 'Question',
        name: '私密视频是否需要付费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '私密视频目前提供免费在线观看服务，用户无需付费即可畅享海量视频资源，高清画质不缓冲，全集资源一站畅享。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系私密视频客服？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过官方网站的联系方式页面提交反馈，或拨打客服热线400-000-0000，我们的客服团队将竭诚为您服务。',
        },
      },
      {
        '@type': 'Question',
        name: '私密视频支持哪些设备观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '私密视频支持PC端、平板、手机等多种设备观看，网页端自适应不同屏幕尺寸，随时随地畅享高清视频内容。',
        },
      },
    ],
  };
}